export * from './auction.service';
export * from './address.service';
export * from './bank.service';
export * from './calendar.service';
export * from './checkList.service';
export * from './checkListItem.service';
export * from './course.service';
export * from './courseRecurrence.service';
export * from './dashboard.service';
export * from './department.service';
export * from './grades.service';
export * from './init-admin.service';
export * from './invoice.service';
export * from './logger.service';
export * from './module.service';
export * from './product.service';
export * from './profile.service';
export * from './recipe.service';
export * from './responsible.service';
export * from './student.service';
export * from './studentCourse.service';
export * from './studentClassesCourse.service';
export * from './supplier.service';
export * from './teacher.service';
export * from './termOfUse.service';
export * from './writingTest.service';
export * from './writingTestApply.service';
export * from './studentClassesCourseAction.service';
